// antd scopes its token CSS variables (`--ant-*`) to a class named after the root
// ConfigProvider's `cssVar.key`. Pinning the key lets non-antd elements opt into the
// same variables by carrying this class, instead of duplicating token values in SCSS.
const ANTD_CSS_VAR_KEY = 'commutifi-antd-css-var';
export { ANTD_CSS_VAR_KEY };